// extracted by mini-css-extract-plugin
module.exports = {"productTag":"ProductTags_productTag__LfXpQ"};